<template>
<div class="pfm-cart-input-field" :class="['state-' + state, {'show-help': this.showHelp}, {'focused': this.focus}, {'filled': this.filled}, {'error' : !isValid}]">

  <div class='main' @click="[setFocus(),setState('typing')]" @focus="setFocus(),setState('typing')">
    <div class='label-wrap' v-if="!showHelp">
      <label :for="this._uid" v-if="isValid">{{label}}<span v-if="!required" class='optional'>(nepovinné)</span></label>
      <span class='error-message' :ref="this._uid + '-error-message'" v-if="!isValid">
        <span>{{errorMessage.active}}</span>
      </span>
    </div>

    <div class='input-wrap' v-show="!showHelp">
      <input v-if="['input'].includes(kind)" :id="this._uid" :class="'state-' + state" v-model="inputValue" ref="inputField" type="text" v-verify="getValidations()" :name="this._uid + '-inputField-' + this.name" :placeholder="placeholder"
        :autocomplete="name" :inputmode="this.inputMode" tabindex="0" spellcheck="false" data-hj-whitelist @focus="setFocus(),setState('typing')" @blur="[setStateAuto(), setDefocus()]" @change="emitUpdate" @keyup="emitUpdate" @paste="emitUpdateValidate">
      <textarea v-if="kind == 'textarea'"></textarea>

      <google-maps-autocomplete v-if="(kind == 'googlemaps-autocomplete')" :id="this._uid + '-' + name + '-map'" :name="this._uid + '-inputField-' + this.name" :class="'state-' + state" :value="inputValue" :ref="this._uid + '-' + 'googleAutocomplete'"
        :restrictAddress="restrictAddress" v-verify="getValidations()" slot="body" classname="form-control" placeholder="Provoněná 1, Praha" :country="['cz']" :types="'address'" tabindex="0" @focus="setFocus(),setValueOnFocus(),setState('typing')"
        @placechanged="getAddressData" @inputChange="addressChanged" @blur="[setStateAuto(), addressBlur()]" />
    </div>

    <div class='help-wrap' v-if="showHelp">
      <p>{{helpText}}</p>
    </div>
  </div>

  <div class='toolbar'>
    <div class='btn-help' v-if="helpText && (['init','typing'].includes(state))" @click="toggleHelp()">
      <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-if="!showHelp" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12 5.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zm0 10.563a.813.813 0 110-1.626.813.813 0 010 1.626zm1.12-3.792c-.358.33-.578.548-.578.812h-1.084c0-.752.514-1.227.927-1.608.433-.4.698-.667.698-1.1a1.084 1.084 0 00-2.166 0H9.833c0-1.195.972-2.167 2.167-2.167 1.195 0 2.167.972 2.167 2.167 0 .929-.58 1.465-1.047 1.896z" fill="#2A313C" fill-rule="nonzero"/></svg>
      <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-if="showHelp" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M12 5.5a6.5 6.5 0 110 13 6.5 6.5 0 010-13zm2.386 3.21l-2.336 2.36-2.334-2.36-.93.92 2.356 2.357-2.357 2.382.83.965 2.436-2.438 2.437 2.438.829-.965-2.358-2.382 2.358-2.356-.93-.92z" fill="#2A313C" fill-rule="nonzero"/></svg>
    </div>
    <div class='state-indicator' v-if="(['progress', 'valid', 'error'].includes(state) && !focus) && !showHelp">
      <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" v-bind:class="'error'" v-bind:svg-inline="''" v-if="!isValid && ['error'].includes(state)" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M15.846 6.546l1.532 1.516-3.881 3.881 3.881 3.922-1.365 1.589L12 13.44l-4.013 4.014-1.365-1.59 3.88-3.92-3.88-3.882 1.532-1.516L12 10.431l3.846-3.885z" fill="#2A313C" fill-rule="nonzero"/></svg>
      <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" v-bind:class="'valid'" v-bind:svg-inline="''" v-if="isValid && ['valid'].includes(state)" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#2A313C" fill-rule="nonzero" d="M17.203 7.02l-7.176 7.176-3.245-3.238-1.384 1.384 4.63 4.638 8.574-8.575z"/></svg>
    </div>
  </div>

</div>
</template>

<script>
import Langs from '@/langs'
import Validator from '@/service/Validator'
import GoogleMapsAutocomplete from '@/components/common/GoogleMapsAutocomplete'

const TYPE_VALIDATIONS = {
  email: 'email',
  note: 'max:120',
  phone: 'phone',
  address: ''
}

export default {
  props: {
    data: Object,
    name: String,
    kind: String, // input | textarea
    label: String,
    inputType: String, // email | ...
    placeholder: String,
    helpText: String,
    required: Boolean,
    slotState: String,
    restrictAddress: Boolean
  },
  components: {
    GoogleMapsAutocomplete
  },
  data() {
    return {
      inputMode: null,
      Validator: Validator,
      focus: false,
      filled: false,
      state: 'init', // init | typing | progress                          | valid | error | disabled
      mode: 'input', // input | help
      showHelp: false,
      inputValue: '',
      valueOnFocus: '',
      selectedAddressFromDropdown: false,
      errors: Validator.errorFields,
      isValid: true,
      addressIsChanged: false,
      errorMessage: {
        default: 'nepřekelpl/a ses?', //'misspelled smoething?'
        active: 'nepřekelpl/a ses?'
      }
    };
  },
  created() {
    console.log('TextField:created: restrictAddress:', this.restrictAddress)
    // console.log('TextField:created', this, this.name, this.kind, this.inputType, this.data[this.name])
    if (this.kind == 'googlemaps-autocomplete') {
      if (typeof this.data[this.name] == 'object') {
        this.inputValue = this.data[this.name].formatted_address //this.getAddress()
      } else {
        this.inputValue = this.data[this.name]
      }

      Validator.add({
        input: {
          name: `${this._uid}-inputField-${this.name}`,
          value: this.addressValidatorFunction
        },
        test: 'required'
      })

    } else {
      if (this.inputType == 'phone') {
        this.inputMode = 'numeric'
      }

      this.inputValue = this.data[this.name]
    }

    if (this.inputValue) {
      console.log('TYPING', this.inputValue)
      this.filled = true
      this.setState('typing')
    }
    // console.log('Value', this.name, this.inputValue)
  },
  beforeDestroy() {
    if (this.kind == 'googlemaps-autocomplete') {
      Validator.remove({
        input: {
          name: `${this._uid}-inputField-${this.name}`
        }
      })
    }
  },
  watch: {
    inputValue: {
      handler() {
        if (this.kind != 'googlemaps-autocomplete') {
          this.data[this.name] = this.inputValue
        }
      }
    },
    errors: {
      handler() {
        this.$nextTick(() => {
          // console.log('watch(): errors', this.showHelp)
          if (!this.showHelp) {
            // console.log('watch(): errors')
            this.isFieldValid()
          }
        })
      }
    },
    data: {
      deep: true,
      handler() {
        // console.log('TextField data updated')
        // if user opens help and then toggles off shippingIsSame, we need to force hide the help, because the fields lives on, but its no longer in shipping section, but rather billing section.
        if (!this.data.shippingIsSame) {
          this.showHelp = false
        }
      }
    }
  },
  methods: {
    addressValidatorFunction() {
      return this.validateAddress(this.data[this.name]) ? 'ok' : null
    },
    isFieldValid() {
      console.log('isFieldValid(): state', this.state)
      this.isValid = !Validator.hasError(`${this._uid}-inputField-${this.name}`)
      if (this.isValid == false) {
        this.setState('error')
      }
    },
    getValidations() {
      // console.log(`Text input ${this.name}, is required? ${this.required}`, TYPE_VALIDATIONS[this.inputType], this.kind)
      if (this.required) {
        if (this.kind == 'googlemaps-autocomplete') {
          return 'required'
        } else {
          return 'required' + (TYPE_VALIDATIONS[this.inputType] ? '|' + TYPE_VALIDATIONS[this.inputType] : '')
        }
      } else if (TYPE_VALIDATIONS[this.inputType]) {
        return TYPE_VALIDATIONS[this.inputType]
      } else {
        return ''
      }
    },
    setState(state) {
      this.state = state
    },
    setStateAuto() {
      if (this.inputValue) {
        // VALIDATE HERE
        this.setState('valid')
        this.filled = true
      } else {
        this.setState('typing') // not init, because i already used the field.
        this.filled = false
      }
    },
    setMode(mode) {
      this.mode = mode
    },
    setValueOnFocus() {
      this.selectedAddressFromDropdown = false // reset
      var currentValue = this.$refs[this._uid + '-googleAutocomplete'].autocompleteText
      console.log('setting value on focus', currentValue)
      this.valueOnFocus = currentValue
    },
    toggleHelp() {
      console.log('toggleHelp()')
      this.showHelp = !this.showHelp
    },
    setFocus() {
      this.focus = true
      this.$nextTick(() => {
        if (this.kind == 'googlemaps-autocomplete') {
          this.$refs[this._uid + '-googleAutocomplete'].focus()
        } else {
          this.$refs.inputField.focus()
        }

      })
    },
    setDefocus() {
      // this is because the @blur is fired before showHelp is set when clicking the ? btn while typing
      setTimeout(() => {
        console.log('setDefocus(): defocusing', this.showHelp)
        this.validate()
        this.focus = false
      }, 300)
    },
    emitUpdate(event) {
      // console.log('emitUpdate', event)
      if (!this.isValid) {
        // Validate if there is already an error
        this.validate()
      }
      this.$emit('updated', this.inputValue, event)
    },
    emitUpdateValidate() {
      this.validate()
      this.$emit('updated', this.inputValue)
    },
    validate() {
      return Validator.validate(`${this._uid}-inputField-${this.name}`)
        .then(result => {
          if (!result) {
            // Notification.add('err', 'Prosím, opravte své údaje', 15)
          }
          return result
        })
    },
    pushOrNot(arr, commaAfter, val) {
      console.log('pushOrNot:', commaAfter, val)
      if (val) {
        arr.push(val)
        if (commaAfter) {
          arr.push(', ')
        } else {
          arr.push(' ')
        }
      }
    },
    addressBlur() {
      console.log('Address field blur')
      this.validateAddress(this.data[this.name])
      this.setDefocus()
    },
    validateAddress(ad) {
      console.log('Validating address:', ad)
      // minimum address requirements -> street number, street name, city, country, postal
      if (ad && ad.street_number && ad.street_number.short_name && ad.route && ad.route.short_name && ad.administrative_area_level_1 && ad.administrative_area_level_1.short_name && ad.country && ad.country.short_name && ad.postal_code && ad.postal_code.short_name) {
        this.isValid = true
        this.filled = true
        this.state = 'valid'
      } else {
        if (ad && !(ad.street_number && ad.street_number.short_name)) {
          this.errorMessage.active = 'ještě číslo ulice, prosím :)'
        } else {
          this.errorMessage.active = 'adresu, prosím, vyber z našeptávače'
        }
        this.isValid = false
        this.filled = this.inputValue == '' ? false : true
        this.state = 'error'
      }
      return this.isValid
    },
    addressChanged(e) {
      this.validateAddress(this.data[this.name])
    },
    getAddressData(address, place) {
      this.selectedAddressFromDropdown = true
      // let country = place.address_components.find(cmp => {return cmp.types.indexOf('country') > -1})
      console.log('New address found', address, place, country)
      this.data[this.name] = address
      console.log('Address inserted into', this.data)
      this.inputValue = address.formatted_address //this.getAddress()
      this.addressIsChanged = false
      this.setDefocus()
      // Place the value into the simple input for validation
      // this.formUpdated()
      this.emitUpdate(this.data[this.name])
      // this.validateAddress(this.data[this.name])
    },
  }
};
</script>

<style lang='less' scoped>
@import '../../variables.less';

.pfm-cart-input-field {
    border: 1px solid @pfm-cart-color-border;
    border-radius: 7px;
    height: 56px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    transition: background 0.5s, box-shadow 0.2s ease-in-out;

    &:hover {
        box-shadow: 0 0 0 1px @pfm-cart-color-border;
    }

    .main {
        // outline: 1px solid #ff0000;
        flex: 1;
        height: 100%;
        padding: 18px 0 18px 18px;
        transition: all 0.2s ease-in-out;
        cursor: text;

        .label-wrap {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;

            label {
                padding-top: 3px;
                font-weight: 500;
                font-size: 0.75rem;
                cursor: text;

                span.optional {
                    padding-left: 5px;
                    color: @pfm-cart-color-form-placeholder;
                }
            }

            span.error-message {}
        }

        .input-wrap {

            span.placeholder {}

            input {
                background: none;
                border: none;
                outline: none;
                font-size: 0.9375rem;
                margin-top: 2px;
                color: @pfm-cart-color-form-text;
                width: 100%;
                height: 100%;
                opacity: 1;

                &.state-init {
                    opacity: 0;
                    height: 0;
                }

                &::placeholder {
                    color: @pfm-cart-color-form-placeholder;
                }
                &:-ms-input-placeholder {
                    color: @pfm-cart-color-form-placeholder;
                }
                &::-webkit-input-placeholder {
                    color: @pfm-cart-color-form-placeholder;
                }
            }
        }

        .help-wrap {
            // transition: all 0.5s;
            p {
              // padding-bottom: 10px;
              line-height: 1.5rem;
            }
        }
    }

    .toolbar {
        // outline: 1px solid #ff0000;
        height: 54px;
        width: 50px;

        div {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            svg {
                width: 30px;
                height: 30px;

                & * {
                    fill: @pfm-cart-color-text-light;
                }
            }
        }

        .btn-help {
            cursor: pointer;

            svg {
                & * {
                    // fill: @pfm-cart-color-form-switch-bg-hover;
                    transition: all 0.2s ease-in-out;
                }
            }

            &:hover {
                svg {
                    & * {
                        fill: @pfm-cart-color-form-switch-bg-hover;
                        transition: all 0.2s ease-in-out;
                    }
                }
            }
        }

        .state-indicator {
            svg.error {
                & * {
                    fill: @pfm-cart-color-danger;
                }
            }

            svg.valid {
                & * {
                    fill: @pfm-cart-color-form-input-tick-valid;
                }
            }
        }
    }

    &.focused {
        // border-width: 2px;
        border-color: @pfm-cart-color-border-focused;
        box-shadow: 0 0 0 1px @pfm-cart-color-border-focused;
        transition: all 0.2s ease-in-out;

        .main {
            padding-top: 8px;
            transition: all 0.2s ease-in-out;
            // padding-bottom: 0px;
            // padding-left: 17px;
            // padding-top: 7px !important;
            // height: calc(100% - 0px);

            .label-wrap {
                height: auto;
                label {
                    padding-top: 0;
                    font-size: 0.625rem;
                }
            }
        }

        .toolbar {
            // width: 48px;
            // height: 52px;
        }
    }

    &.state-typing {
        .main {
            padding-top: 8px;

            .label-wrap {
                height: auto;

                label {
                    padding-top: 0;
                    font-size: 0.625rem;
                }
            }
        }
    }

    &.error {
        border-color: @pfm-cart-color-danger;
        box-shadow: 0 0 0 1px @pfm-cart-color-danger;
        transition: all 0.2s ease-in-out;

        .main {
            padding-top: 8px;

            .label-wrap {
                height: auto;

                span.error-message {
                    color: @pfm-cart-color-danger;
                    padding-top: 0;
                    font-size: 0.625rem;
                }
            }
            .input-wrap {}
        }
    }

    &.show-help {
        height: auto;
        transition: all 0.5s;
        background-color: @pfm-cart-color-form-bg-help;
        border: none;
        box-shadow: none;

        .main {
            padding-top: 18px;
        }

        .toolbar {
            height: 56px;
            width: 52px;
        }
    }

    &.filled {

        .main {
            padding-top: 8px;
            // padding-bottom: 0;

            .label-wrap {
                height: auto;
                label {
                    padding-top: 0;
                    font-size: 0.625rem;
                }
            }

            .help-wrap {
              padding-top: 10px;
            }
        }
    }

}
</style>
